import axios from "axios";

export const USER_REQ = "USER_REQ";
export const GET_USER = "GET_USER";
export const COMMENT_REQ = "COMMENT_REQ";
export const COMMENT_ERR = "COMMENT_ERR";
export const REPLY_REQ = "REPLY_REQ";
export const REPLY_ERR = "REPLY_ERR";
export const USER_FAILURE = "USER_FAILURE";
export const GET_BLOGS_REQ = "GET_BLOGS_REQ";
export const GET_BLOGS_ERROR = "GET_BLOGS_ERROR";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOG_SUCCESS = "GET_BLOG_SUCCESS";
export const GET_TRASH_SUCCESS = "GET_TRASH_SUCCESS";
export const GET_COMMENT_SUCCESS = "GET_COMMENT_SUCCESS";
export const GET_COMMENT_REPLY = "GET_COMMENT_REPLY";
export const GET_USERS = "GET_USERS";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const SET_SUCCESS = "SET_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";
export const USER_PROFILE = "USER_PROFILE";

const isLocalhost = window.location.hostname === "localhost";
export const baseURL = isLocalhost
  ? "http://localhost:8080"
  : "https://full-stack-blog-application-mu.vercel.app";

export const getUser = (dispatch) => {
  dispatch({
    type: USER_REQ,
  });

  let token =
    localStorage.getItem("jwtoken") || localStorage.getItem("refreshToken");

  axios
    .get(`${baseURL}/verify`, {
      withCredentials: true,
      headers: {
        Authorization: token,
      },
    })
    .then((res) => {
      dispatch({
        type: GET_USER,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: USER_FAILURE,
      });
      dispatch({
        type: LOGOUT_USER,
      });
    });
};

export const getBlogs = (dispatch, search = "") => {
  dispatch({
    type: GET_BLOGS_REQ,
  });

  axios
    .get(`${baseURL}/blogs?q=${search}`, {
      withCredentials: true,
    })
    .then((res) => {
      dispatch({
        type: GET_BLOGS_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_BLOGS_ERROR,
      });
    });
};

export const getBlog = (dispatch, id) => {
  dispatch({
    type: GET_BLOGS_REQ,
  });

  axios
    .get(`${baseURL}/blogs/${id}`, {
      withCredentials: true,
    })
    .then((res) => {
      dispatch({
        type: GET_BLOG_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_BLOGS_ERROR,
      });
    });
};

export const getComments = (dispatch, id) => {
  dispatch({
    type: COMMENT_REQ,
  });

  axios
    .get(`${baseURL}/comments/${id}`, {
      withCredentials: true,
    })
    .then((res) => {
      dispatch({
        type: GET_COMMENT_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: COMMENT_ERR,
      });
    });
};

export const getCategories = (dispatch) => {
  axios
    .get(`${baseURL}/category`, {
      withCredentials: true,
    })
    .then((res) => {
      dispatch({
        type: GET_CATEGORIES,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getCommentsReply = (dispatch, id) => {
  dispatch({
    type: REPLY_REQ,
  });

  axios
    .get(`${baseURL}/comments/${id}`, {
      withCredentials: true,
    })
    .then((res) => {
      dispatch({
        type: GET_COMMENT_REPLY,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: REPLY_ERR,
      });
    });
};

export const getTrash = (dispatch) => {
  dispatch({
    type: GET_BLOGS_REQ,
  });

  let token =
    localStorage.getItem("jwtoken") || localStorage.getItem("refreshToken");

  axios
    .get(`${baseURL}/trash`, {
      withCredentials: true,
      headers: {
        Authorization: token,
      },
    })
    .then((res) =>
      dispatch({
        type: GET_TRASH_SUCCESS,
        payload: res.data,
      })
    )
    .catch((err) => {
      dispatch({
        type: GET_BLOGS_ERROR,
      });
    });
};

export const updateBlog = (payload, id, dispatch) => {
  dispatch({
    type: GET_BLOGS_REQ,
  });
  let token =
    localStorage.getItem("jwtoken") || localStorage.getItem("refreshToken");

  axios
    .put(`${baseURL}/blogs/${id}`, payload, {
      withCredentials: true,
      headers: {
        Authorization: token,
      },
    })
    .then((res) => console.log(res))
    .catch((err) => {
      dispatch({
        type: GET_BLOGS_ERROR,
      });
    });
};

export const getUserProfile = (dispatch) => {
  dispatch({
    type: USER_REQ,
  });

  let token =
    localStorage.getItem("jwtoken") || localStorage.getItem("refreshToken");

  axios
    .get(`${baseURL}/users/user`, {
      withCredentials: true,
      headers: {
        Authorization: token,
      },
    })
    .then((res) =>
      dispatch({
        type: USER_PROFILE,
        payload: res.data,
      })
    )
    .catch((err) => {
      dispatch({
        type: USER_FAILURE,
      });
    });
};

export const logoutUser = (dispatch) => {
  dispatch({
    type: LOGOUT_USER,
  });
};
